export default __webpack_public_path__ + "static/media/danabos.378bf8e5.svg";